// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2UFJO","errorLogs":"EditorFooter_errorLogs__2Qb27"};